// Copyright (c) 2016 Deere & Company

import LaborStatsReport from '@deere/cps-it.warranty-model-factory/lib/labor-stats';
import t from 'tcomb';

const Report = t.list(LaborStatsReport, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/labor-stats/state/report.js